
export default [{
	path: '/warehouses-reports',
	component: () => import('@/components/warehouses-reports/Main')
}]
